import React from 'react'
import Blocks from './_Blocks'

const BackgroundBlock = ({ block }) => {
  return (
    <section
      className={`background-block ${block.type ? block.type : ''} ${
        block.space_top ? block.space_top : ''
      } ${block.space_bottom ? block.space_bottom : ''}`}
      style={{ backgroundImage: 'url(' + block.background_image + ')' }}
    >
      {block.body?.length > 0 &&
        block.body.map((content) =>
          React.createElement(Blocks(content.component), {
            key: content._uid,
            block: content,
            type: content.component,
          })
        )}
    </section>
  )
}

export default BackgroundBlock
